import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomCardWrapper, CustomText, } from "@corporate-trip-planner-fe/ui-styles";
import Goa from "./../../../assets/images/goa.avif";
import { getImageUrl } from "./../../../utils/helpers/functions";
var formatTripRange = function (startDateStr, endDateStr) {
    if (!startDateStr || !endDateStr)
        return "";
    var parseDate = function (str) {
        var _a = str.split("-").map(Number), day = _a[0], month = _a[1], year = _a[2];
        return new Date(year, month - 1, day);
    };
    var start = parseDate(startDateStr);
    var end = parseDate(endDateStr);
    // Formatting options for "9 Dec"
    var dayMonthOptions = {
        day: "numeric",
        month: "short",
    };
    var startFormatted = start.toLocaleDateString("en-IN", dayMonthOptions);
    var endFormatted = end.toLocaleDateString("en-IN", dayMonthOptions);
    var yearFormatted = end.getFullYear();
    // Returns "9 Dec - 11 Dec, 2025"
    return "".concat(startFormatted, " - ").concat(endFormatted, ", ").concat(yearFormatted);
};
function TripCoverBanner(_a) {
    var trip = _a.trip;
    return (_jsxs(CustomCardWrapper, { background: "linear-gradient(rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%), url(".concat(trip.coverImage ? getImageUrl(trip.coverImage) : Goa, ") center/cover no-repeat"), "$maxWidth": "100%", "$height": "40vh", borderRadius: "0 0 32px 32px" // Rounded bottom corners
        , display: "flex", "$flexDirection": "column", "$justifyContent": "flex-end", padding: "24px", "$cursor": "auto", alignItems: "start", children: [_jsx(CustomText, { "$color": "white", "$fontSize": "2rem", "$fontWeight": "800", "$margin": "0 0 8px 0", style: { lineHeight: "1.2" }, children: trip.tripName }), _jsxs(CustomText, { "$color": "rgba(255, 255, 255, 0.9)", "$fontSize": "1rem", "$fontWeight": "500", "$display": "flex", "$alignItems": "left", children: [formatTripRange(trip.startDate, trip.endDate), trip.destination && (_jsxs(_Fragment, { children: [_jsx("span", { style: { margin: "0 8px" }, children: "\u2022" }), trip.destination] }))] })] }));
}
export default TripCoverBanner;
